export default __webpack_public_path__ + "static/media/ValvesImg.5f3cde28.jpg";